/**
 * Guest-realm source for the Vault extension. Vault is host-rendered
 * (VaultSidebar.js + VaultView.js) and calls the Rust vault commands directly
 * via invoke — secrets never enter the guest sandbox. This entry script is a
 * no-op kept only to satisfy the extension registration contract.
 */
export const vaultEntrySource = `
(function () {
  var sdk = window.apibooSDK;
  sdk.onActivate(function () {});
})();
`;
